import { TableResult } from './types';

const NAME_MAPPINGS: { [key: string]: string } = {
  "SM-102": "25499",
  "Cholesterol": "CHL",
  "DMG-PEG2000": "DMGL",
  "DMG-PEG5000": "DMGL",
  "DSPE-PEG5000": "DSPE",
  "DLin-MC3-DMA": "25497",
};


export const formatValue = (value: string | number | boolean | null | undefined): string => {
  if (value === null || value === undefined) {
    return 'N/A';
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }
  if (typeof value === 'number') {
    return value.toFixed(2);
  }
  const num = Number(value);

  if (!isNaN(num) && value.trim() !== "") {
    return num.toFixed(2);
  }
  return value;
};

export const formatExperimentValue = (value: string | null): string => {
  if (!value) return '-';
  const num = Number(value);
  return isNaN(num) ? value : num.toFixed(2);
};

export const getLnpIdFormatted = (index: number): string => {
  return `lnp-${String(index).padStart(6, '0')}`;
};

export const getIonizableLipidImagePath = (index: number): string => {
  return `/ionizableLipid/LNP_${String(index).padStart(7, '0')}.svg`;
};

export const getHelperLipidImagePath = (name: string): string => {
  return `/helperLipid/${name}.svg`;
};

export const getCholesterolImagePath = (name: string): string => {
  return `/cholesterol/CHL.svg`;
};
export const generateClipboardText = (result: TableResult): string => {
  let effectiveIlName = result.il_name;

  if (result.experiment_id && result.experiment_id.includes("BroadPharm")) {
    if (effectiveIlName && effectiveIlName.startsWith("BP-")) {
      effectiveIlName = effectiveIlName.substring(3);
    }
    const lineContent = `${effectiveIlName}:DSPC:CHL:DMGL=50:10:38:2`;
    return `upper -> ${lineContent}
lower -> ${lineContent}`;
  }
  const components = [
    { name: effectiveIlName, ratio: result.il_molratio },
    { name: result.hl_name, ratio: result.hl_molratio },
    { name: result.chl_name, ratio: result.chl_molratio },
    { name: result.peg_name, ratio: result.peg_molratio },
  ];

  const validComponents = components.filter(
    (comp) => comp.name !== null && comp.name !== ""
  );

  const values = validComponents.map((comp) => parseFloat(comp.ratio || "0"));
  const total = values.reduce((sum, val) => sum + val, 0);

  let finalRatios: number[] = [];

  if (total === 0) {
    finalRatios = values.map(() => 0);
  } else {
    const normalized = values.map((v) => (v / total) * 100);
    const floored = normalized.map((v) => Math.floor(v));
    
    const currentSum = floored.reduce((a, b) => a + b, 0);
    const deficit = 100 - currentSum;

    const remainders = normalized.map((v, i) => ({ val: v - floored[i], index: i }));
    remainders.sort((a, b) => b.val - a.val);

    for (let i = 0; i < deficit; i++) {
      floored[remainders[i].index] += 1;
    }
    finalRatios = floored;
  }

  const nameString = validComponents
    .map((comp) => NAME_MAPPINGS[comp.name!] || comp.name)
    .join(":");
  const ratioString = finalRatios.join(":");

  const lineContent = `${nameString}=${ratioString}`;

  return `upper -> ${lineContent}
lower -> ${lineContent}`;
};